<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/calendar.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("schedule overview") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="pl-md-12 pa-8 SalesCalendarWrap" id="SalesCalendarMain">
      <img
        src="../assets/img/slide.svg"
        class="scroll-icon"
        alt="Scrolling Icon"
        width="30"
      />
      <div
        class="row disablerow align-items-start justify-content-end justify-between"
      >
        <div class="toggleWrap">
          <router-link
            to="/calendar"
            tag="button"
            class="savebutton v-btn v-size--default switchBtn"
          >
            <img src="../assets/img/arrow_right.png" alt="Icon" />
            {{ $t("default_view") }}
          </router-link>
          <router-link
            to="/sales-calendar"
            tag="button"
            class="savebutton v-btn v-size--default switchBtn activeBtn"
          >
            <img src="../assets/img/arrow_right.png" alt="Icon" />
            {{ $t("sales_calendar") }}
          </router-link>
        </div>
        <v-btn
          :href="`/api/calendar/export/` + selectedYear"
          v-show="$rights.includes('DOWNLOAD_CALENDER_CSV')"
          outlined
          depressed
          tile
          class="savebutton mb-2 ml-5 relativeBtn"
          >{{ $t("export_csv") }}</v-btn
        >

        <div
          id="salesFilterWrapScroll"
          v-bind:class="{ stickyFilter: isSticky }"
        >
          <div class="salesFilterWrap">
            <div class="calendar-year-next-prev">
              <button class="today_btn" @click="todayClicked()">
                {{ $t("today") }}
              </button>
              <button
                class="btn btn-info btn-arrow wpreviousBtn"
                @click="previousYearClicked()"
                title="Previous Year"
              >
                <v-icon>fa-solid fa-chevron-left</v-icon>
              </button>
              <div class="selectedYearNumber">
                {{ $t("year") }} {{ selectedYear }}
              </div>
              <button
                class="btn btn-info btn-arrow wnextBtn"
                @click="nextYearClicked()"
                title="Next Year"
              >
                <v-icon>fa-solid fa-chevron-right</v-icon>
              </button>
            </div>
            <div class="salesFilterWrapParent">
              <div class="custom-select-dropdown custom-month-dropdown">
                <v-autocomplete
                  v-model="monthFilter"
                  hide-details="auto"
                  class="justify-content-end searchbar align-self-center"
                  :items="monthsList"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  :label="$t('select_month')"
                  @change="changeMonth()"
                >
                  <template v-slot:append></template>
                </v-autocomplete>
              </div>
              <div class="custom-select-dropdown custom-location-dropdown">
                <v-autocomplete
                  v-model="locationFilter"
                  hide-details="auto"
                  class="justify-content-end searchbar align-self-center"
                  :items="locationsList"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  :label="$t('viewAllTrainerLocation')"
                >
                  <template v-slot:append></template>
                </v-autocomplete>
              </div>
              <div class="custom-select-dropdown custom-location-dropdown">
                <v-autocomplete
                  v-model="roomlocationFilter"
                  hide-details="auto"
                  class="justify-content-end searchbar align-self-center"
                  :items="roomslocationsList"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  :label="$t('viewAllRoomLocation')"
                >
                  <template v-slot:append></template>
                </v-autocomplete>
              </div>
              <div class="custom-select-dropdown custom-trainers-dropdown">
                <v-autocomplete
                  v-model="trainersFilter"
                  hide-details="auto"
                  class="justify-content-end searchbar align-self-center"
                  :items="trainersList"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  :label="$t('viewAllTrainers')"
                  @change="changeTrainerType()"
                >
                  <template v-slot:append></template>
                </v-autocomplete>
              </div>
            </div>
          </div>
        </div>
        <!-- Left Area -->
        <v-btn
          :href="`/api/calendar/export/` + selectedYear"
          v-show="$rights.includes('DOWNLOAD_CALENDER_CSV')"
          outlined
          depressed
          tile
          class="savebutton mb-2 mr-sm-16 hideCSVButon"
          >{{ $t("export_csv") }}</v-btn
        >

        <div class="col-xl-12 px-0 pb-0 topJanIssue">
          <div class="mx-0 pa-0 text-content mt-0">
            <div class="pt-0">
              <div class="calendar-year">
                <div>
                  <img
                    class="ml-2 arrow-img-left clickable"
                    @click="previousYearClicked()"
                    src="../assets/img/arrow_right.svg"
                    height="18px"
                  />
                </div>
                <div>{{ selectedYear }}</div>
                <div>
                  <img
                    class="ml-2 clickable"
                    @click="nextYearClicked()"
                    src="../assets/img/arrow_right.svg"
                    height="18px"
                  />
                </div>
              </div>
              <div
                class="calendar-month"
                v-for="(month, index) in allObjects"
                :key="index"
                v-show="monthNames[index] != null && monthNames[index] != ''"
                :id="monthNames[index]"
                :class="{ active: activeCalendarMonth === index }"
                :data-id="trainersFilterEdited"
              >
                <div
                  class="month_scroller_wrap"
                  :class="{ active: activeMonth === index }"
                >
                  <div class="calendar-first-row">
                    <div>&nbsp;</div>
                    <div class="bg-blue">
                      {{ $t(monthNames[index]) }} {{ selectedYear }}
                    </div>
                  </div>
                  <div class="calendar-content-row">
                    <div class="bg-beige-dark firColmn">{{ $t("date") }}</div>
                    <div
                      class="bg-beige-dark weekday"
                      v-bind:class="[
                        {
                          'bg-blue': day == currentDay && index == currentMonth,
                        },
                        getWeekdayKey(index, day),
                      ]"
                      v-for="day in 31"
                      :key="day"
                    >
                      {{ isNextMonth(index, day) ? "" : day }}
                    </div>
                  </div>
                  <div class="calendar-content-row">
                    <div class="bg-beige-dark firColmn">&nbsp;</div>
                    <div
                      class="bg-beige-dark weekday"
                      v-for="day in 31"
                      :key="day"
                      v-bind:class="[
                        {
                          'bg-blue': day == currentDay && index == currentMonth,
                        },
                        getWeekdayKey(index, day),
                      ]"
                    >
                      {{
                        isNextMonth(index, day)
                          ? ""
                          : getWeekdayName(index, day)
                      }}
                    </div>
                  </div>
                  <div class="calendar-content-row">
                    <div class="bg-beige-dark firColmn">{{ $t("KW") }}</div>
                    <div
                      class="bg-beige-dark weekday week-of-year"
                      v-for="day in 31"
                      :key="day"
                      v-bind:class="[
                        {
                          'bg-blue': day == currentDay && index == currentMonth,
                        },
                        getWeekdayKey(index, day),
                      ]"
                    >
                      <span
                        v-if="
                          (index === 0 && day === 1) ||
                          (getWeekdayNumber(index, day) == 1 &&
                            !isNextMonth(index, day))
                        "
                        >{{
                          isNextMonth(index, day)
                            ? ""
                            : getWeekOfYear(index, day)
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="calendar-content-row">
                    <div class="bg-beige firColmn"></div>
                    <div
                      class="bg-beige"
                      v-for="day in 31"
                      :key="day"
                      v-bind:class="[
                        {
                          borderBlue:
                            day == currentDay && index == currentMonth,
                        },
                        getWeekdayKey(index, day),
                      ]"
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>

                <!-- Appointments for Trainers -->
                <div
                  class="calendar-content-row"
                  v-for="(
                    trainerAppointment, index
                  ) in month.trainerAppointments"
                  v-bind:class="trainerAppointment.trainerType"
                  v-if="
                    locationFilter === 'View all Trainer locations' ||
                    (locationFilter === trainerAppointment.trainerLocation &&
                      locationFilter !== 'View all Trainer locations')
                  "
                >
                  <div class="bg-beige firColmn">
                    <p class="trainerName">
                      <img
                        class="trainerTypeImg"
                        src="../assets/img/trainer-icon.svg"
                      />
                      {{ trainerAppointment.fullname }}
                    </p>
                    <p
                      class="trainerTypeName"
                      v-if="trainerAppointment.trainerType === 'fullTime'"
                    >
                      <span>
                        <img
                          class="trainerTypeImg"
                          src="/static/img/fulltime@2x.png"
                        />
                      </span>
                      {{ $t("full_time") }}
                    </p>
                    <p
                      class="trainerTypeName trainerPartTypeName"
                      v-if="trainerAppointment.trainerType === 'partTime'"
                    >
                      <span>
                        <img
                          class="trainerTypeImg"
                          src="/static/img/parttime@2x.png"
                        />
                      </span>
                      {{ $t("part_time") }}
                    </p>
                    <p class="trainerLoc">
                      <v-icon>fas fa-map-marker-alt</v-icon>
                      {{
                        trainerAppointment.trainerLocation
                          ? $t(trainerAppointment.trainerLocation)
                          : ""
                      }}
                    </p>
                  </div>
                  <div
                    class="bg-beige calendar-day"
                    v-for="(
                      day, index
                    ) in trainerAppointment.daysWithAppointments"
                    :key="index"
                    @click.stop="
                      calendarDayClicked(
                        trainerAppointment.trainer,
                        day.day,
                        month.month,
                        'TRAINER',
                        day.appointment
                      )
                    "
                    :set="(appointmentOnDay = day.appointment)"
                    v-bind:class="[
                      {
                        borderBlue:
                          day.day == currentDay && month.month == currentMonth,
                        sundayEnd:
                          getWeekdayKeys(index, day.day, month.month) === 'Sun',
                        mondayStart:
                          getWeekdayKeys(index, day.day, month.month) === 'Mon',
                      },
                      getAppointment(
                        trainerAppointment,
                        day.day,
                        month.month
                      ) == null
                        ? null
                        : getAppointment(
                            trainerAppointment,
                            day.day,
                            month.month
                          ).type.toLowerCase(),
                      getWeekdayKey(index, day),
                    ]"
                  >
                    <span v-if="appointmentOnDay != null">
                      <span v-show="appointmentOnDay.type == 'VACATION'">
                        U
                      </span>
                      <span v-show="appointmentOnDay.type == 'ABSENCE'">
                        A
                      </span>
                      <span
                        v-show="appointmentOnDay.type == 'TRAINING_AS_TRAINER'"
                      >
                        T
                      </span>
                      <span
                        v-show="appointmentOnDay.type == 'TRAINING_INITIATIVE'"
                      >
                        O
                      </span>
                      <span
                        v-show="appointmentOnDay.type == 'TRAINING_DEVELOPMENT'"
                      >
                        E
                      </span>
                      <span
                        v-show="appointmentOnDay.type == 'PREPARATION_TIME'"
                      >
                        V
                      </span>
                      <span v-show="appointmentOnDay.type == 'TRAVEL_TIME'">
                        R
                      </span>
                      <span
                        v-show="appointmentOnDay.type == 'FURTHER_EDUCATION'"
                      >
                        W
                      </span>
                      <span
                        v-show="appointmentOnDay.type == 'POSTPROCESSION_TIME'"
                      >
                        N
                      </span>
                      <span v-show="appointmentOnDay.type == 'SERVICE'">
                        FS
                      </span>
                      <span v-show="appointmentOnDay.type == 'HOLIDAY'">
                        F
                      </span>
                      <span v-show="appointmentOnDay.type == 'MISCELLANEOUS'">
                        S
                      </span>
                      <div class="hover-element text-left">
                        <span
                          v-bind:class="{
                            'clickable-link': appointmentOnDay.clickable,
                          }"
                          @click.stop="
                            appointmentClicked(
                              getAppointment(
                                trainerAppointment,
                                day.day,
                                month.month
                              )
                            )
                          "
                          >{{
                            appointmentOnDay.designationsMap[$locale] != null
                              ? appointmentOnDay.designationsMap[$locale]
                              : $t(
                                  "appointment_type_" +
                                    appointmentOnDay.type.toLowerCase()
                                )
                          }}</span
                        >
                        <v-divider></v-divider>
                        <span
                          class="font-grey"
                          v-html="appointmentOnDay.description"
                        ></span>
                      </div>
                    </span>
                    <span v-else>&nbsp;</span>
                  </div>
                </div>

                <!-- Appointments for Rooms -->
                <div
                  class="calendar-content-row"
                  v-for="roomAppointment in month.roomAppointments"
                  v-if="
                    roomlocationFilter === 'View all Room locations' ||
                    (roomlocationFilter === roomAppointment.roomLocation &&
                      roomlocationFilter !== 'View all Room locations')
                  "
                >
                  <div class="bg-beige firColmn">
                    <p class="trainerName">
                      <img
                        class="trainerTypeImg"
                        src="../assets/img/room-icon.svg"
                      />
                      {{ roomAppointment.room.designation }}
                    </p>
                    <p class="roomLoc">
                      <v-icon>fas fa-map-marker-alt</v-icon>
                      {{ $t(roomAppointment.roomLocation) }}
                    </p>
                  </div>
                  <div
                    class="bg-beige calendar-day"
                    v-for="(day, index) in roomAppointment.daysWithAppointments"
                    :key="index"
                    @click.stop="
                      calendarDayClicked(
                        roomAppointment.room.id,
                        day.day,
                        month.month,
                        'ROOM',
                        day.appointment
                      )
                    "
                    :set="(appointmentOnDay = day.appointment)"
                    v-bind:class="[
                      {
                        borderBlue:
                          day.day == currentDay && month.month == currentMonth,
                        sundayEnd:
                          getWeekdayKeys(index, day.day, month.month) === 'Sun',
                        mondayStart:
                          getWeekdayKeys(index, day.day, month.month) === 'Mon',
                      },
                      day.appointment == null
                        ? null
                        : day.appointment.type.toLowerCase(),
                      getWeekdayKey(index, day),
                    ]"
                  >
                    <span v-if="appointmentOnDay != null">
                      <span v-show="appointmentOnDay.type == 'ROOM_BLOCKED'">
                        RB
                      </span>
                      <div class="hover-element text-left">
                        <span
                          v-bind:class="{
                            'clickable-link': appointmentOnDay.clickable,
                          }"
                          @click.stop="
                            appointmentClicked(
                              getAppointment(
                                roomAppointment,
                                day.day,
                                month.month
                              )
                            )
                          "
                          >{{
                            appointmentOnDay.designationsMap[$locale] != null
                              ? appointmentOnDay.designationsMap[$locale]
                              : $t(
                                  "appointment_type_" +
                                    appointmentOnDay.type.toLowerCase()
                                )
                          }}</span
                        >
                        <v-divider></v-divider>
                        <span
                          class="font-grey"
                          v-html="appointmentOnDay.description"
                        ></span>
                      </div>
                    </span>
                    <span v-else>&nbsp;</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-dialog v-model="openAddDialog">
        <div class="cal-app">
          <h3 v-show="appointment.id == null">{{ $t("add_appointment") }}</h3>
          <h3 v-show="appointment.id != null">{{ $t("edit_appointment") }}</h3>
          <br />
          <div class="row">
            <div class="col-sm-6 col-md-6">
              <DatePicker
                v-model="appointment.start"
                clearable
                :label="$t('begin_date')"
              />
            </div>
            <div class="col-sm-6 col-md-6">
              <DatePicker
                v-model="appointment.end"
                clearable
                :label="$t('end_date')"
              />
            </div>
            <div class="col-sm-12 col-md-12">
              <v-select
                dense
                outlined
                class="datainput"
                hide-details="auto"
                :items="appointmentTypesUpdated"
                item-text="text"
                item-value="value"
                :label="$t('type') + '*'"
                v-model="appointment.type"
                :disabled="dialog.type == 'ROOM'"
              ></v-select>
            </div>
            <div class="col-sm-12 col-md-12" v-show="dialog.type == 'TRAINER'">
              <v-autocomplete
                v-model="appointment.userReference"
                hide-details="auto"
                class="datainput justify-content-end searchbar align-self-center pb-1"
                :items="trainers"
                item-text="fullname"
                item-value="id"
                style="padding-right: 2px"
                dense
                outlined
                :label="$t('user')"
              >
              </v-autocomplete>
            </div>
            <div class="col-sm-12 col-md-12">
              <v-textarea
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1"
                dense
                outlined
                :label="$t('description')"
                v-model="appointment.description"
                clearable
              ></v-textarea>
            </div>
            <div class="col-sm-12 col-md-12 pt-0">
              <v-checkbox
                v-if="appointment.type == 'MISCELLANEOUS'"
                v-model="appointment.productive"
                class="no-margin-top"
                :label="'Productive'"
              ></v-checkbox>
            </div>
          </div>
          <div class="text-center">
            <v-dialog v-model="openDeleteDialog" width="500">
              <h4>{{ $t("confirm_delete_Appoinment") }}</h4>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  @click="openDeleteDialog = false"
                  outlined
                  depressed
                  tile
                  class="cancelbutton cancelBtn mr-2 mb-2"
                >
                  {{ $t("cancel") }}</v-btn
                >
                <v-btn
                  @click="deleteAppointment()"
                  outlined
                  depressed
                  tile
                  class="deletebutton cancelBtn mr-2 mb-2"
                >
                  <v-icon color="#444">mdi-delete</v-icon>
                  {{ $t("delete") }}</v-btn
                >
              </v-card-actions>
            </v-dialog>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              v-show="$rights.includes('CREATE_APPOINTMENT')"
              @click="saveAppointment()"
              outlined
              depressed
              tile
              class="savebutton"
              >{{ $t("save") }}</v-btn
            >
            <v-btn
              @click="openAddDialog = false"
              outlined
              depressed
              tile
              class="cancelBtn mr-2"
            >
              {{ $t("cancel") }}</v-btn
            >
            <v-btn
              @click="openDeleteDialog = true"
              v-show="
                !appointment.clickable &&
                appointment.id != null &&
                $rights.includes('DELETE_APPOINTMENT')
              "
              outlined
              depressed
              tile
              class="deletebutton cancelBtn mr-2 mb-0"
            >
              <v-icon color="#444">mdi-delete</v-icon> {{ $t("delete") }}</v-btn
            >
          </v-card-actions>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      activeMonth: null,
      activeCalendarMonth: null,
      openDeleteDialog: false,
      days: [],
      trainerAppointments: [],
      roomAppointments: [],
      weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: [],
      currentDay: null,
      currentMonth: null,
      selectedYear: null,
      dialog: {
        type: "TRAINER",
      },
      openAddDialog: false,
      trainers: [],

      allObjects: [],

      appointmentTypes: [],

      monthFilter: [],
      locationFilter: [],
      locationsList: [],
      roomlocationFilter: [],
      roomslocationsList: [],
      trainersFilter: [],
      trainersFilterEdited: [],
      appointment: {
        id: null,
        start: null,
        end: null,
        reference: null,
        userReference: null,
        description: null,
        productive: null,
      },

      isSticky: false,
    };
  },
  computed: {
    trainersList() {
      return [
        { id: "View all Trainers", name: this.$t("viewAllTrainers") },
        { id: "Full Time", name: this.$t("full_time") },
        { id: "Part Time", name: this.$t("part_time") },
      ];
    },

    appointmentTypesUpdated() {
      return this.appointmentTypes.map((type) => ({
        text: this.$t("appointment_type_" + type.toLowerCase()),
        value: type,
      }));
    },

    monthNames() {
      return [
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },
    monthsList() {
      return [
        this.$t("select_month"),
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },
  },

  mounted() {
    this.handleScroll = this.debounce(this.handleScroll, 100);

    window.addEventListener("storage", this.handleStorageChange);
    this.currentDay = new Date().getDate();
    this.currentMonth = new Date().getMonth();
    this.selectedYear = new Date().getFullYear();

    this.fetchAppointments();
    this.fetchTrainers();
    this.fetchAppointmentTypes();
    window.addEventListener("scroll", this.handleScroll);
    this.locationFilter = "View all Trainer locations";
    this.roomlocationFilter = "View all Room locations";
    for (let i = 0; i <= 12; i++) {
      this.allObjects.push({
        month: i,
        trainerAppointments: [],
        roomAppointments: [],
      });
    }

    var monthCounter = 0;
    var i = 0;
    while (i <= 12) {
      this.months.push(monthCounter);
      i++;
      monthCounter++;
      if (monthCounter > 12) monthCounter = 0;
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("storage", this.handleStorageChange);
  },

  methods: {
    debounce(func, wait = 100) {
      let timeout;
      return () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this), wait);
      };
    },

    getWeekdayKey(month, day) {
      const year = this.selectedYear;
      var dt = new Date(year, month, day);
      return this.weekdays[dt.getDay()];
    },
    getWeekdayKeys(index, day, month) {
      const year = this.selectedYear;
      var dt = new Date(year, month, day);
      return this.weekdays[dt.getDay()];
    },
    handleStorageChange(event) {
      if (event.key === "counterValue") {
        this.counter = event.newValue;
        let text = event.newValue.split("-");
        if (text[0] == "update" || text[0] == "create") {
          this.fetchAppointments();
        } else {
          for (var i = 0; i < this.allObjects.length; i++) {
            //trainer appintments
            for (
              let index = 0;
              index < this.allObjects[i].trainerAppointments.length;
              index++
            ) {
              const element =
                this.allObjects[i].trainerAppointments[index]
                  .daysWithAppointments;
              for (let month = 0; month < element.length; month++) {
                const daywiseData = element[month];

                if (daywiseData.appointment != null) {
                  console.log(daywiseData.appointment.trainingEventId);
                  if (
                    daywiseData.appointment.trainingEventId != "undefined" &&
                    daywiseData.appointment.trainingEventId == text[0]
                  ) {
                    daywiseData.appointment = null;
                  }
                }
              }
            }

            //room appintments
            for (
              let index = 0;
              index < this.allObjects[i].roomAppointments.length;
              index++
            ) {
              const element =
                this.allObjects[i].roomAppointments[index].daysWithAppointments;
              for (let month = 0; month < element.length; month++) {
                const daywiseData = element[month];

                if (daywiseData.appointment != null) {
                  console.log(daywiseData.appointment.trainingEventId);
                  if (
                    daywiseData.appointment.trainingEventId != "undefined" &&
                    daywiseData.appointment.trainingEventId == text[0]
                  ) {
                    daywiseData.appointment = null;
                  }
                }
              }
            }
          }
        }
      }
    },
    onError(err) {
      console.log("getEndDateFormateInfo");
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    fetchAppointments() {
      const { selectedYear } = this;

      this.$axios
        .get(`/api/calendar/fetchtrainerroom`)
        .then((resp) => {
          let trainers = resp.data.trainers.map((trainer) => {
            // Return an object with only the desired properties
            return {
              id: trainer.id,
              fullname: trainer.fullname,
              firstname: trainer.firstname,
              lastname: trainer.lastname,
              trainerLocation: trainer.trainerLocation,
              tenantLocation: trainer.tenantLocation,
              trainerType: trainer.trainerType,
            };
          });
          let rooms = resp.data.rooms.map((rm) => {
            // Return an object with only the desired properties
            return {
              id: rm.id,
              roomLocation: rm.roomLocation,
            };
          });
          const req = {
            trainers: trainers,
            rooms: rooms,
          };

          const totalMonths = 12;

          for (let i = 1; i <= totalMonths; i++) {
            const trainerPromise = this.$axios.post(
              `/api/calendar/trainer/${selectedYear}/${i}`,
              req
            );
            const roomPromise = this.$axios.post(
              `/api/calendar/room/${selectedYear}/${i}`,
              req
            );

            Promise.all([trainerPromise, roomPromise])
              .then(([trainerResponse, roomResponse]) => {
                const monthIndex = i - 1;
                this.allObjects[monthIndex].trainerAppointments =
                  trainerResponse.data.trainerAppointments;
                this.allObjects[monthIndex].roomAppointments =
                  roomResponse.data.roomAppointments;

                if (monthIndex === 0) {
                  this.locationsList = [
                    {
                      id: "View all Trainer locations",
                      name: this.$t("viewAllTrainerLocation"),
                    },
                    ...trainerResponse.data.trainerAppointments.map(
                      (appointment) => appointment.trainerLocation
                    ),
                  ];
                  this.roomslocationsList = [
                    {
                      id: "View all Room locations",
                      name: this.$t("viewAllRoomLocation"),
                    },
                    ...roomResponse.data.roomAppointments.map(
                      (appointment) => appointment.roomLocation
                    ),
                  ];
                }

                // Update the DOM for the current month
                this.$forceUpdate();
              })
              .catch(this.onError);
          }
        })
        .catch(this.onError);
    },

    fetchAppointmentTypes() {
      var _this = this;
      this.$axios
        .get("/api/calendar/types")
        .then((response) => {
          const types = response.data.filter(
            (type) =>
              type !== "TRAINING_AS_PARTICIPANT" &&
              type !== "TRAINING_AS_TRAINER"
          );

          _this.appointmentTypes = types;
        })
        .catch(this.onError);
    },

    fetchTrainers() {
      var _this = this;
      this.$axios
        .get("/api/user/trainer")
        .then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            if (Number.isInteger(element)) {
              _this.fetchSingleTrainerAndPush(element);
            } else {
              _this.trainers.push(element);
            }
          }
        })
        .catch(this.onError);
    },

    fetchSingleTrainerAndPush(trainerId) {
      var _this = this;
      this.$axios
        .get("/api/user/" + trainerId)
        .then(function (response) {
          const element = response.data;
          _this.trainers.push(element);
        })
        .catch(this.onError);
    },

    onFinally() {
      showLoadingCircle(false);
    },

    // Date Functions
    getWeekdayName(month, day) {
      const year = this.selectedYear;
      var dt = new Date(year, month, day);
      return this.$t(this.weekdays[dt.getDay()]);
    },
    getWeekdayNumber(month, day) {
      const year = this.selectedYear;
      var dt = new Date(year, month, day);
      return dt.getDay();
    },
    getWeekOfYear1(month, day) {
      const year = this.selectedYear;
      const dt = new Date(year, month, day);

      // Add 3 hours to the date
      dt.setHours(dt.getHours() + 3);

      const oneJan = new Date(year, 0, 0);
      const week = Math.floor((dt - oneJan) / 86400000);
      const result = Math.ceil(week / 7);
      return result;
    },
    containsJan1st(startOfWeek) {
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      const jan1stCurrentYear = new Date(startOfWeek.getFullYear(), 0, 1);
      const jan1stNextYear = new Date(startOfWeek.getFullYear() + 1, 0, 1);
      return (
        (startOfWeek <= jan1stCurrentYear && jan1stCurrentYear <= endOfWeek) ||
        (startOfWeek <= jan1stNextYear && jan1stNextYear <= endOfWeek)
      );
    },
    getMondayOfWeek(year, month = 1, day = 1) {
      const date = new Date(year, month - 1, day); // month is 0-indexed
      const dayOfWeek = date.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
      const mondayDate = new Date(date.getTime()); // Ensure mondayDate is a Date object copy

      // Calculate the difference to the previous Monday
      const differenceToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      mondayDate.setDate(date.getDate() + differenceToMonday);

      return mondayDate; // return as a Date object
    },
    getTotalWeeksInYear(year) {
      const firstDay = new Date(year, 0, 1);
      const lastDay = new Date(year, 11, 31);
      const firstThursday = new Date(firstDay);
      firstThursday.setDate(
        firstThursday.getDate() + ((4 - firstThursday.getDay() + 7) % 7)
      );
      const lastThursday = new Date(lastDay);
      lastThursday.setDate(
        lastThursday.getDate() - ((lastThursday.getDay() + 3) % 7)
      );
      const oneWeek = 1000 * 60 * 60 * 24 * 7;
      const totalWeeks =
        Math.ceil((lastThursday - firstThursday) / oneWeek) + 1; // +1 to include the first week
      return totalWeeks;
    },
    getWeekOfYear(month, day) {
      const year = this.selectedYear;
      const dt = new Date(year, month, day);
      // Add 3 hours to the date
      dt.setHours(dt.getHours() + 3);

      // Calculate the day of the week (Sunday = 0, Monday = 1, ..., Saturday = 6)
      let dayOfWeek = dt.getDay();
      if (dayOfWeek === 0) dayOfWeek = 7; // Make Sunday = 7, Monday = 1, etc.

      // Set the current date to the Thursday of the current week
      dt.setDate(dt.getDate() + (4 - dayOfWeek));

      // Get the first Thursday of the year
      const firstThursday = new Date(dt.getFullYear(), 0, 4); // Always January 4th or later
      let firstThursdayDayOfWeek = firstThursday.getDay();
      if (firstThursdayDayOfWeek === 0) firstThursdayDayOfWeek = 7; // Adjust Sunday = 7

      // Adjust to ensure the first Thursday of the year
      firstThursday.setDate(
        firstThursday.getDate() + (4 - firstThursdayDayOfWeek)
      );

      // Calculate the difference in days between the current Thursday and the first Thursday
      const diffInDays = Math.floor((dt - firstThursday) / 86400000); // Milliseconds to days

      // Calculate the week number
      const weekNumber = Math.floor(diffInDays / 7) + 1;

      return weekNumber;
    },

    isNextMonth(monthToCheck, day) {
      var dt = new Date(this.selectedYear, monthToCheck, day);
      if (dt.getMonth() != monthToCheck) return true;
      return false;
    },
    getDay(date) {
      return new Date(date).getDate();
    },
    getMonth(date) {
      return new Date(date).getMonth();
    },
    getYear(date) {
      return new Date(date).getYear();
    },
    getAppointment(trainerAppointment, day, month) {
      return trainerAppointment.daysWithAppointments[day - 1].appointment;
    },

    previousYearClicked() {
      this.selectedYear--;
      this.fetchAppointments();
    },
    nextYearClicked() {
      this.selectedYear++;
      this.fetchAppointments();
    },

    //new functions start

    //today click
    todayClicked() {
      const todayYear = new Date().getFullYear();
      this.selectedYear = todayYear;
      this.fetchAppointments();
      const todayMonthList = [
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
      const todayMonth = todayMonthList[new Date().getMonth()];
      document.getElementById(todayMonth).scrollIntoView();
    },

    //change month filter funtion
    changeMonth() {
      document.getElementById(this.monthFilter).scrollIntoView();
    },

    //change trainerType filter funtion
    changeTrainerType() {
      this.trainersFilterEdited = this.trainersFilter.replaceAll(" ", "");
    },

    handleScroll() {
      let isActiveMonthSet = false;
      let isActiveCalendarMonthSet = false;

      // Track scroll direction and store in buffer
      let bufferState = this.bufferState || {
        lastIndex: null,
        lastScrollY: window.scrollY,
        lastDirection: null,
      };

      // Calculate scroll direction
      let currentScrollY = window.scrollY;
      let scrollDirection =
        currentScrollY > bufferState.lastScrollY ? "down" : "up";
      bufferState.lastScrollY = currentScrollY;

      // Threshold for scroll change to activate a new month
      let bufferThreshold = 150;

      this.monthNames.forEach((month, index) => {
        const monthElement = document.getElementById(month);
        if (monthElement) {
          const children = monthElement.querySelectorAll(":scope > *");
          const monthRect = monthElement.getBoundingClientRect();

          // For .month_scroller_wrap
          if (children.length > 0) {
            const firstChildRect = children[0].getBoundingClientRect();
            const lastChildRect =
              children[children.length - 1].getBoundingClientRect();

            // Handle scroll down
            if (
              scrollDirection === "down" &&
              firstChildRect.top <= 0 &&
              lastChildRect.bottom > bufferThreshold
            ) {
              // Activate the current month if scrolling down
              this.activeMonth = index;
              isActiveMonthSet = true;
              bufferState.lastIndex = index;
              bufferState.lastDirection = "down";
            }
            // Handle scroll up
            else if (
              scrollDirection === "up" &&
              lastChildRect.bottom > bufferThreshold
            ) {
              // Activate the previous month if scrolling up
              if (bufferState.lastIndex !== index) {
                this.activeMonth = index;
                isActiveMonthSet = true;
                bufferState.lastIndex = index;
                bufferState.lastDirection = "up";
              }
            }
          }

          // For .calendar-month
          if (monthRect.top <= 0 && monthRect.bottom > bufferThreshold) {
            this.activeCalendarMonth = index;
            isActiveCalendarMonthSet = true;
          }
        }
      });

      // Reset if no active month is set
      if (!isActiveMonthSet) {
        this.activeMonth = null;
      }
      if (!isActiveCalendarMonthSet) {
        this.activeCalendarMonth = null;
      }

      // Store buffer state
      this.bufferState = bufferState;

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1920) {
        this.isSticky = scrollTop > 790; // Adjust this value for larger screens
      } else {
        this.isSticky = scrollTop > 570; // Default value for smaller screens
      }
    },

    //new functions end

    appointmentClicked(appointmentOnDay) {
      if (!appointmentOnDay.clickable) return;
      if (
        appointmentOnDay.type == "TRAINING_AS_TRAINER" ||
        appointmentOnDay.type == "ROOM_BLOCKED"
      ) {
        let route = this.$router.resolve({
          path:
            "/edit-training-event?trainingEventId=" +
            appointmentOnDay.reference,
        });
        window.open(route.href, "_blank");
      }
    },

    calendarDayClicked(
      reference,
      day,
      month,
      mode = "TRAINER",
      appointmentOnDay
    ) {
      if (!this.$rights.includes("CREATE_APPOINTMENT")) return;
      if (this.isNextMonth(month, day)) return;
      this.clearAppointment();

      // Open Dialog and Set Type
      this.openAddDialog = true;
      this.dialog.type = mode;

      if (mode == "ROOM") {
        this.appointment.type = "ROOM_BLOCKED";
        this.appointment.reference = reference;
      }

      const selectedMonthReadable = month + 1;
      const dayString = day < 10 ? "0" + day : day;
      const monthString =
        selectedMonthReadable < 10
          ? "0" + selectedMonthReadable
          : selectedMonthReadable;
      const fullDateString =
        this.selectedYear + "-" + monthString + "-" + dayString;
      this.appointment.start = fullDateString + "T00:00:00";
      this.appointment.end = fullDateString + "T23:59:59";
      this.appointment.userReference = mode == "TRAINER" ? reference : null;

      // Show edit Dialog
      if (appointmentOnDay != null) {
        this.appointment.id = appointmentOnDay.id;
        this.appointment.start = appointmentOnDay.start;
        this.appointment.end = appointmentOnDay.end;
        this.appointment.userReference = appointmentOnDay.userReference;
        this.appointment.type = appointmentOnDay.type;
        this.appointment.description = appointmentOnDay.description;
        this.appointment.clickable = appointmentOnDay.clickable;
        this.appointment.productive = appointmentOnDay.productive;

        // Check if Edit Dialog shall be shown
        if (
          this.appointment.type == "TRAINING_AS_TRAINER" ||
          (this.appointment.type == "ROOM_BLOCKED" &&
            this.appointment.userReference == null)
        ) {
          this.openAddDialog = false;
        }
      }
      this.$forceUpdate();
    },

    clearAppointment() {
      this.appointment = {
        id: null,
        start: null,
        end: null,
        userReference: null,
        description: null,
      };
    },

    saveAppointment() {
      var _this = this;

      var appointment = Object.assign({}, this.appointment);

      if (
        typeof appointment.start == "string" &&
        appointment.start.length < 11
      ) {
        appointment.start = appointment.start + "T00:00:00";
      }
      if (typeof appointment.end == "string" && appointment.end.length < 11) {
        appointment.end = appointment.end + "T23:59:59";
      }

      if (appointment.id == null) {
        this.$axios
          .post("/api/calendar/create", appointment)
          .then(function (response) {
            _this.updateForAppointment(appointment, response.data, "create");
            _this.openAddDialog = false;
            _this.$noty.success(_this.$t("appointment_saved"));
          })
          .catch(this.onError);
      } else {
        let resp = null;
        _this.$axios.get(`/api/calendar/${appointment.id}`).then((resp) => {
          resp = resp;
          _this.$axios
            .put("/api/calendar/" + appointment.id, appointment)
            .then(function (response) {
              _this.updateForAppointment(resp.data, resp.data, "delete");
              _this.updateForAppointment(appointment, response.data, "update");
              _this.openAddDialog = false;
              _this.$noty.success(_this.$t("appointment_edited"));
            })
            .catch(this.onError);
        });
      }
    },

    deleteAppointment() {
      var _this = this;
      this.openAddDialog = false;
      this.openDeleteDialog = false;
      var appointment = Object.assign({}, this.appointment);
      progressIndicator.hidden = false;
      showLoadingCircle(true);

      this.$axios
        .delete("/api/calendar/" + appointment.id)
        .then(function (response) {
          _this.updateForAppointment(appointment, response.data, "delete");
          _this.openAddDialog = false;
          _this.$noty.success(_this.$t("appointment_deleted"));
        })
        .catch(this.onError)
        .finally(() => {
          progressIndicator.hidden = true;
          document.getElementById("loadingCircle").classList.remove("zIndex");
        });
    },
    updateForAppointment(appointment, res, type) {
      var _this = this;
      let startDate = new Date(appointment.start);
      let endDate = new Date(appointment.end);
      let startMonth = startDate.getMonth() + 1; // getMonth() returns 0-11, so add 1 for 1-12
      let startYear = startDate.getFullYear();
      let endMonth = endDate.getMonth() + 1;
      let endYear = endDate.getFullYear();
      let currentMonth = startMonth;
      let currentYear = startYear;

      res.userReference = res.userReference.id;
      res.reference = res.reference;
      res.designationsMap = res.designations;
      res.clickable = false;
      res.startDayOfMonth = startDate.getDate();
      res.endDayOfMonth = endDate.getDate();
      while (
        currentYear < endYear ||
        (currentYear === endYear && currentMonth <= endMonth)
      ) {
        let daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
        if (
          currentYear === startYear &&
          currentYear === endYear &&
          currentMonth === startMonth &&
          currentMonth === endMonth
        ) {
          _this.updateAppointment(
            _this.allObjects,
            currentYear,
            currentMonth,
            startDate.getDate(),
            endDate.getDate(),
            res,
            type
          );
        } else if (currentYear === startYear && currentMonth === startMonth) {
          _this.updateAppointment(
            _this.allObjects,
            currentYear,
            currentMonth,
            startDate.getDate(),
            daysInMonth,
            res,
            type
          );
        } else if (currentYear === endYear && currentMonth === endMonth) {
          _this.updateAppointment(
            _this.allObjects,
            currentYear,
            currentMonth,
            1,
            endDate.getDate(),
            res,
            type
          );
        } else {
          _this.updateAppointment(
            _this.allObjects,
            currentYear,
            currentMonth,
            1,
            daysInMonth,
            res,
            type
          );
        }
        if (currentMonth === 12) {
          currentMonth = 1;
          currentYear++;
        } else {
          currentMonth++;
        }
      }
    },

    updateAppointment(
      existingObject,
      year,
      month,
      startDay,
      endDay,
      newAppointment,
      type
    ) {
      if (!newAppointment.reference) {
        existingObject[month - 1].trainerAppointments.forEach((trainer) => {
          if (trainer.trainer === newAppointment.userReference) {
            for (let day = startDay; day <= endDay; day++) {
              let dayString = `${year}-${month
                .toString()
                .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
              let dayObject = trainer.daysWithAppointments.find(
                (d) => d.date === dayString
              );
              if (type === "create" || type === "update") {
                dayObject.appointment = newAppointment;
              } else if (type === "delete") {
                dayObject.appointment = null;
              }
            }
          }
        });
      } else {
        existingObject[month - 1].roomAppointments.forEach((room) => {
          if (room.room.id === newAppointment.reference) {
            for (let day = startDay; day <= endDay; day++) {
              let dayString = `${year}-${month
                .toString()
                .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
              let dayObject = room.daysWithAppointments.find(
                (d) => d.date === dayString
              );
              if (type === "create" || type === "update") {
                dayObject.appointment = newAppointment;
              } else if (type === "delete") {
                dayObject.appointment = null;
              }
            }
          }
        });
      }
    },
  },
};
</script>
